import script from "./XTitleIconLabel.vue?vue&type=script&lang=ts&setup=true"
export * from "./XTitleIconLabel.vue?vue&type=script&lang=ts&setup=true"

import "./XTitleIconLabel.vue?vue&type=style&index=0&id=27cefdd0&lang=scss&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27cefdd0"]])

export default __exports__